module.exports = __webpack_public_path__ + "img/delete.38a9249c.svg";